import { Box, Link, Typography, useMediaQuery } from '@mui/material';
import { useAccount } from '../../contexts/Account';
import MembershipIcon from '../../images/membership-icon.svg';
import PrivateIcon from '../../images/private-icon.svg';
import DoubleClickIcon from '../../images/double-click-icon.svg';
import CometBlueIcon from '../../images/comet-blue-icon.svg';
import AdvisoryMac from '../../images/advisory_mac.png';

const AdvisoryBoardsHeader = (props) => {
  const { peerPage } = props;
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { isFreemium } = useAccount();
  const bulletPoints = [
    {
      text: 'Instantly join any of the advisory boards built on AdvisoryCloud',
      image: MembershipIcon,
    },
    {
      text: 'New boards for startups, non-profits and private companies added weekly',
      image: PrivateIcon,
    },
    {
      text: "Receive monthly board recommendations and updates related to boards you're on",
      image: DoubleClickIcon,
    },
    {
      text: 'See how easy, exciting and rewarding it is to share your ideas across a portfolio of different advisory boards',
      image: CometBlueIcon,
    },
  ];

  function getTitleSize() {
    if (isSM) return '20px';
    if (!peerPage) return '32px';
    return '40px';
  }

  function getTitleHeight() {
    if (isSM) return '24px';
    if (!peerPage) return '40px';
    return '52px';
  }

  function getImageWidth() {
    if (isSM) return '100%';
    if (!peerPage) return '640px';
    return null;
  }

  function getImageMaxWidth() {
    if (isSM) return '550px';
    if (!peerPage) return '640px';
    return null;
  }

  function getImageMinWidth() {
    if (isSM) return null;
    if (!peerPage) return '640px';
    return null;
  }

  const ImageBox = (
    <Box
      width={getImageWidth()}
      maxWidth={getImageMaxWidth()}
      minWidth={getImageMinWidth()}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: isSM ? '16px' : '0',
        ml: !isSM ? '75px' : null,
        justifySelf: isSM && !peerPage ? 'center' : null,
      }}
    >
      <img
        src={
          peerPage
            ? 'https://d9hhrg4mnvzow.cloudfront.net/register.advisorycloud.com/platform/annual-offer/c4d29d7e-group-8699_10s80ku000000000000028.png'
            : AdvisoryMac
        }
        alt="Peer Advisory Boards"
        style={{ width: '100%', height: 'auto' }}
      />
    </Box>
  );

  return (
    <Box
      mb={peerPage ? '16px' : '32px'}
      sx={{
        display: 'flex',
        flexDirection: isSM ? 'column' : 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: getTitleSize(),
            fontWeight: 600,
            lineHeight: getTitleHeight(),
            textAlign: { xxs: 'center', xs: 'left' },
            color: '#001030',
            marginBottom: '12px',
          }}
        >
          {peerPage
            ? 'Experience the benefits and ROI of joining a peer advisory board.'
            : 'Welcome to the largest collection of advisory boards, available to join exclusively on AdvisoryCloud.'}
        </Typography>

        {isSM && !peerPage && ImageBox}
        {peerPage ? (
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              textAlign: 'left',
              color: '#4D586F',
            }}
          >
            Immediately join one of our 9 types of peer advisory boards that
            have monthly meetings on current career opportunities, networking,
            compensation trends, and the sharing of best practices.
          </Typography>
        ) : (
          <Box
            sx={{
              display: { xxs: isFreemium ? 'none' : 'block', sm: 'block' },
            }}
          >
            {bulletPoints.map((bullet, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: '16px',
                  alignItems: 'center',
                }}
              >
                <img
                  src={bullet.image}
                  alt="icon"
                  style={{ marginRight: '15px', width: '30px' }}
                />
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '20.8px',
                  }}
                >
                  {bullet.text}&nbsp;
                  <Link href={bullet.link} target="_blank">
                    {bullet.linkText}
                  </Link>
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
      {!isSM && !peerPage && ImageBox}
    </Box>
  );
};

export default AdvisoryBoardsHeader;
